import { render, staticRenderFns } from "./ReportLink.vue?vue&type=template&id=57e623e0&scoped=true"
import script from "./ReportLink.vue?vue&type=script&lang=js"
export * from "./ReportLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e623e0",
  null
  
)

export default component.exports